<header class="sticky top-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-xl">
    <div class="container mx-auto px-4 h-16 flex items-center justify-between">

        <!-- LOGO -->
        <a routerLink="/" class="flex items-center gap-2 group">
            <div class="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center border border-primary/20 group-hover:bg-primary/20 transition-colors">
                <!-- Code icon -->
                <svg class="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="16 18 22 12 16 6" />
                    <polyline points="8 6 2 12 8 18" />
                </svg>
            </div>
            <span class="font-display font-bold text-lg tracking-tight">blitzkrieg0.0.0.0</span>
        </a>

        <!-- DESKTOP NAV -->
        <nav class="hidden md:flex items-center gap-8">

            <!-- DROPDOWN -->
            <div class="relative group">
                <button class="text-sm font-medium transition-colors hover:text-primary flex items-center gap-1" type="button">
                    MY RESUME
                    <svg class="w-4 h-4 transition-transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                <!-- DROPDOWN MENU -->
                <div class="absolute left-0 mt-2 w-56 rounded-lg bg-white shadow-lg border
               opacity-0 invisible group-hover:opacity-100 group-hover:visible
               transition-all duration-200 z-50">
                    <a routerLink="/resume" class="block px-4 py-2 text-sm hover:bg-slate-100 transition">
                        Resume
                    </a>
                    <a routerLink="/resume-tr" class="block px-4 py-2 text-sm hover:bg-slate-100 transition">
                        Öz Geçmiş
                    </a>
                    <a routerLink="/resume-one" class="block px-4 py-2 text-sm hover:bg-slate-100 transition">
                        Resume - ATS
                    </a>
                    <a routerLink="resume-one-tr" class="block px-4 py-2 text-sm hover:bg-slate-100 transition">
                        Öz Geçmiş - ATS
                    </a>
                </div>
            </div>

            <a *ngFor="let link of links" [routerLink]="link.href" class="text-sm font-medium transition-colors hover:text-primary" [ngClass]="{
          'text-primary font-semibold': isActive(link.href),
          'text-muted-foreground': !isActive(link.href)
        }">
                {{ link.label }}
            </a>

            <!-- <button class="bg-primary/10 text-primary hover:bg-primary/20 border border-primary/20 text-sm px-3 py-1 rounded-md">
                Contact Me
            </button> -->
        </nav>

        <!-- MOBILE TOGGLE -->
        <button class="md:hidden p-2 text-muted-foreground hover:text-foreground" (click)="toggleMenu()">
            <ng-container *ngIf="isOpen; else menuIcon">
                <!-- X icon -->
                <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </ng-container>

            <ng-template #menuIcon>
                <!-- Menu icon -->
                <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
            </ng-template>
        </button>
    </div>

    <!-- MOBILE MENU -->
    <div *ngIf="isOpen" class="md:hidden border-t border-border/40 bg-background px-4 py-4 space-y-4
         animate-in slide-in-from-top-4 fade-in">

        <!-- RESUME DROPDOWN -->
        <div class="space-y-2">
            <button type="button" (click)="toggleResume()" class="w-full flex items-center justify-between
             text-sm font-medium transition-colors hover:text-primary">
                MY RESUME
                <svg class="w-4 h-4 transition-transform" [class.rotate-180]="isResumeOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            <!-- DROPDOWN ITEMS -->
            <div *ngIf="isResumeOpen" class="pl-4 space-y-2">
                <a routerLink="/resume" (click)="closeMenu()" class="block text-sm text-muted-foreground hover:text-primary transition" [ngClass]="{
                    'text-primary': isActive('/resume'),
                    'text-muted-foreground': !isActive('/resume')
                    }">
                    Resume
                </a>
                <a routerLink="/resume-tr" (click)="closeMenu()" class="block text-sm text-muted-foreground hover:text-primary transition" [ngClass]="{
                    'text-primary': isActive('/resume-tr'),
                    'text-muted-foreground': !isActive('/resume-tr')
                    }">
                    Öz Geçmiş
                </a>
                <a routerLink="/resume-one" (click)="closeMenu()" class="block text-sm text-muted-foreground hover:text-primary transition" [ngClass]="{
                    'text-primary': isActive('/resume-one'),
                    'text-muted-foreground': !isActive('/resume-one')
                    }">
                    Resume – ATS
                </a>
                <a routerLink="/resume-one-tr" (click)="closeMenu()" class="block text-sm text-muted-foreground hover:text-primary transition" [ngClass]="{
                    'text-primary': isActive('/resume-one-tr'),
                    'text-muted-foreground': !isActive('/resume-one-tr')
                    }">
                    Öz Geçmiş – ATS
                </a>
            </div>
        </div>

        <!-- OTHER LINKS -->
        <a *ngFor="let link of links" [routerLink]="link.href" (click)="closeMenu()" class="block text-sm font-medium py-2 transition-colors" [ngClass]="{
      'text-primary': isActive(link.href),
      'text-muted-foreground': !isActive(link.href)
    }">
            {{ link.label }}
        </a>

    </div>

</header>